import { keyframes } from "@emotion/react"
import { classes } from "utils"
import { colors } from "design/colors"

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Loader = ({ className }) => {
  return (
    <div
      className={classes(className, "loader-container")}
      css={{
        margin: "auto auto",
        padding:20
      }}
    >
      <div
        className={classes(className, "loader")}
        css={{
          border: `4px solid ${colors.grey200}`, // Lighter border color for background
          borderTop: `4px solid ${colors.primaryBlueGrey}`, // Blue border for spinning effect
          borderRadius: "50%",
          width: 40,
          height: 40,
          animation: `${spin} 1s infinite linear`,
          margin: "auto auto",
        }}
      />
    </div>
  )
}
